
export enum ArticleType {
    General = 1,
    Product = 2,
    Story = 3,
}